import React from "react"
import GlobalContextProvider from "./src/context/GlobalContextProvider"

export function wrapRootElement({ element }) {
  return <GlobalContextProvider>{element}</GlobalContextProvider>
}
